export const style = {
  card: {
    display: "flex",
    alignItems: "center",
    padding: "0.8rem 1.2rem",
    borderBottom: "0.1rem solid var(--gray-20)",
    cursor: "pointer",
    backgroundColor: "var(--neutral-100)",
  },
  active: { backgroundColor: "var(--peach-300)" },
  avatar: {
    width: "2.4rem",
    height: "2.4rem",
    borderRadius: "2.4rem",
  },
  teamDetail: {
    marginLeft: "1.2rem",
  },
  name: {
    margin: 0,
    color: "var(--black-900)",
    fontSize: "1.2rem",
    fontWeight: 400,
  },
  role: {
    margin: 0,
    color: "var(--gray-400)",
    fontSize: "1.2rem",
    fontWeight: 400,
  },
};
